module.exports = __webpack_public_path__ + "img/buy3kabove2000off.84ff3eae.webp";